import { createAction, createReducer } from '@reduxjs/toolkit';
import { Entity, getListRowLink, getRowKey } from 'gossamer-unified';

export type ListInfo = {
  paths: string[];
  originPagePath: string;
  originPageSearch: string;
};

export type ListInfoState = Record<string, ListInfo>;

const INITIAL_STATE: ListInfoState = {};

export interface SetPathsPayload {
  entityId: string;
  info: ListInfo;
}
export const setInfo = createAction<SetPathsPayload>('Lists/setInfo');

export const listInfoReducer = createReducer(INITIAL_STATE, builder => {
  builder.addCase(setInfo, (state, action) => {
    state[action.payload.entityId] = action.payload.info;
  });
});

// Selectors
export const selectListInfo = (state: { lists: ListInfoState }, entityId: string): ListInfo | undefined =>
  state.lists[entityId];

// helpers
export const convertKeysToPaths = <T extends {}>(entity: Entity<T>, rows: T[]) =>
  rows.map(row => getListRowLink(entity.listRowLink, getRowKey(entity, row)));
